<div class="wetter_content_container">
  <div class="bericht-text-container">
    <h3>Zusammenfassung</h3>
    {{deutschlandBericht?.zusammenfassung}}
  </div>
  <div class="bericht-text-container">
    <h3>Vorhersagen</h3>
    <span class="bericht-text-sub-label">Heute</span>
    {{deutschlandBericht?.vorhersageHeute}}
    <span class="bericht-text-sub-label">Kommende Nacht</span>
    {{deutschlandBericht?.vorhersageKommendeNacht}}
  </div>
  <div class="bericht-text-container">
    <h3>Aussichten</h3>
    <ng-container *ngFor="let aussichtTag of deutschlandBericht?.aussichten?.aussichtsListe">
      <span class="bericht-text-sub-label">{{aussichtTag.datum | date: 'EEE dd.MM'}}</span>
      {{aussichtTag.text}}
    </ng-container>
  </div>
</div>

